var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"question-tab"},[_c('p',[_vm._v(_vm._s(_vm.heading))]),_c('div',{staticClass:"button-div"},_vm._l((_vm.data),function(item){return _c('button',{key:item.id,class:_vm.selectedBrands.length!=0 && _vm.selectedBrands.includes(item.id)
          ? 'green-btn'
          : 'default-btn',on:{"click":function($event){return _vm.handleClick(item)}}},[_vm._v(" "+_vm._s(item.name)+" ")])}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }